// eslint-disable-next-line no-unused-vars
import React from 'react';
import { object } from 'prop-types';
import { withTranslation } from 'react-i18next';

import ProductPropType from 'Types/product';
import ProductAbstract from 'Containers/ProductAbstract';
import ProductGridItemComponent from 'Components/Products/ProductGridItem';

import withCart from 'AppSrc/hocs/withCart';
import withWishlist from 'AppSrc/hocs/withWishlist';
import withUser from 'AppSrc/hocs/withUser';
import withProducts from 'AppSrc/hocs/withProducts';
import withFetch from 'AppSrc/hocs/withFetch';
import withModals from 'AppSrc/hocs/withModals';
import withToastNotifications from 'AppSrc/hocs/withToastNotifications';

@withProducts
@withFetch
@withUser
@withCart
@withWishlist
@withModals
@withToastNotifications
@withTranslation()
export default class ProductGridItem extends ProductAbstract {
  render() {
    const { product, addToCartLoading } = this.state;
    return (
      <ProductGridItemComponent
        product={ product }
        addToCartLoading={ addToCartLoading }
        onQuickView={ this.handleOnQuickView }
        onAddToCart={ this.handleOnAddToCart }
        onStockAlertModalOpen={ this.handleStockAlertModalOpen }
        onAddToWishlist={ this.handleOnAddToWishlist }
        onChangeQuantity={ this.handleOnChangeQuantity }
      />
    );
  }
}

ProductGridItem.propTypes = {
  product: ProductPropType,
  wishlists: object,
};
